<template>
	<span
		v-if="delta && delta.kind !== 'none'"
		class="inline-flex items-center gap-1 rounded-md bg-surface-3/80 px-1.5 py-0.5 text-[11px] font-medium leading-4 tabular-nums"
		:class="toneClass"
		:title="title"
	>
		<svg v-if="delta.kind === 'up' || delta.kind === 'down'" width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true" :class="{ 'rotate-180': delta.kind === 'down' }">
			<path d="M5 8.5V1.5M5 1.5L1.75 4.75M5 1.5L8.25 4.75" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
		</svg>
		<span>{{ delta.label }}</span>
	</span>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
	// { kind: 'up'|'down'|'flat'|'new'|'none', label }
	delta: {
		type: Object,
		default: null,
	},
	// "vs previous 28 days" — only used for the title; the card shows it on its own row.
	suffix: {
		type: String,
		default: '',
	},
});

// Deliberately neutral: a drop in plays is not always bad news, so the chip
// reports direction without judging it.
const toneClass = computed(() => (props.delta?.kind === 'flat' ? 'text-surface-8' : 'text-surface-9'));

const title = computed(() => {
	if (!props.delta) return '';
	if (props.delta.kind === 'new') return 'No activity in the previous period';
	if (props.delta.kind === 'flat') return 'No change from the previous period';
	return `${props.delta.kind === 'up' ? 'Up' : 'Down'} ${props.delta.label} ${props.suffix}`.trim();
});
</script>
